export default "__VITE_ASSET__AD7MS1V0__"